var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-context", {
    ref: "contextMenu",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(child) {
          return _c("ul", { staticClass: "context-menu-list" }, [
            _c(
              "li",
              {
                staticClass: "context-menu-item title",
                style: {
                  "background-color":
                    _vm.themeConfig.navbarColor + " !important"
                }
              },
              [
                _vm._v(
                  " " + _vm._s(child && child.data ? child.data.name : "") + " "
                )
              ]
            ),
            child.data && child.data.isFolder
              ? _c(
                  "li",
                  {
                    staticClass: "context-menu-item",
                    on: {
                      click: function($event) {
                        return _vm.emitAction("edit-folder", child.data)
                      }
                    }
                  },
                  [_vm._v(" Editar Nombre ")]
                )
              : _vm._e(),
            child.data && child.data.isFolder
              ? _c(
                  "li",
                  {
                    staticClass: "context-menu-item",
                    on: {
                      click: function($event) {
                        return _vm.emitAction("add-folder", child.data)
                      }
                    }
                  },
                  [_vm._v(" Agregar Carpeta ")]
                )
              : _vm._e(),
            child.data && child.data.isFolder
              ? _c(
                  "li",
                  {
                    staticClass: "context-menu-item",
                    on: {
                      click: function($event) {
                        return _vm.emitAction("add-parameter", child.data)
                      }
                    }
                  },
                  [_vm._v(" Agregar parámetro ")]
                )
              : _vm._e(),
            child.data && !child.data.isFolder
              ? _c(
                  "li",
                  {
                    staticClass: "context-menu-item",
                    on: {
                      click: function($event) {
                        return _vm.emitAction("edit-parameter", child.data)
                      }
                    }
                  },
                  [_vm._v(" Editar Item ")]
                )
              : _vm._e(),
            child.data && !child.data.isFolder
              ? _c(
                  "li",
                  {
                    staticClass: "context-menu-item",
                    on: {
                      click: function($event) {
                        return _vm.emitAction("copy-parameter", child.data)
                      }
                    }
                  },
                  [_vm._v(" Copiar Item ")]
                )
              : _vm._e()
          ])
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }